import { render, staticRenderFns } from "./AtencionReceta.vue?vue&type=template&id=a145b046"
import script from "./AtencionReceta.vue?vue&type=script&lang=js"
export * from "./AtencionReceta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports